import PropTypes from 'prop-types';
import { Component } from 'react';
import PortalIdParser from 'PortalIdParser';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedHTMLMessage';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import H2 from 'UIComponents/elements/headings/H2';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIMatchTextArea from 'UIComponents/input/UIMatchTextArea';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UIButton from 'UIComponents/button/UIButton';
import UIAlert from 'UIComponents/alert/UIAlert';
import { trackScreen } from '../lib/tracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class SelfDeletionConfirmModal extends Component {
  constructor(props) {
    super(props);
    this.handleMatchedChange = ({
      target: {
        value
      }
    }) => {
      this.setState({
        isMatched: value
      });
    };
    this.handleConfirm = () => {
      const {
        onConfirmAction
      } = this.props;
      this.setState({
        errorDismissed: false
      });
      onConfirmAction();
    };
    this.handleDismissError = () => {
      this.setState({
        errorDismissed: true
      });
    };
    this.state = {
      isMatched: false,
      errorDismissed: true
    };
  }
  componentDidMount() {
    trackScreen('gdpr-delete-modal');
  }
  renderAlertMaybe() {
    const {
      deleteFailed,
      deleteSucceeded,
      modalType
    } = this.props;
    const {
      errorDismissed
    } = this.state;
    if (deleteSucceeded) {
      return /*#__PURE__*/_jsx(UIAlert, {
        className: "m-bottom-4",
        use: "inline",
        type: "success",
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `userPreferences.${modalType}.successAlert.title`
        }),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `userPreferences.${modalType}.successAlert.message`
        })
      });
    }
    if (deleteFailed && !errorDismissed) {
      return /*#__PURE__*/_jsx(UIAlert, {
        className: "m-bottom-4",
        use: "inline",
        type: "danger",
        closeable: true,
        onClose: this.handleDismissError,
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `userPreferences.${modalType}.failureAlert.title`
        }),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `userPreferences.${modalType}.failureAlert.message`
        })
      });
    }
    return null;
  }
  render() {
    const {
      deletePending,
      deleteFailed,
      onCloseModal,
      emailAddress,
      modalType
    } = this.props;
    const {
      isMatched
    } = this.state;
    return /*#__PURE__*/_jsxs(UIModal, {
      size: "auto",
      use: "danger",
      onEsc: onCloseModal,
      children: [/*#__PURE__*/_jsx(UIDialogHeader, {
        children: /*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `userPreferences.${modalType}.modalHeader`
          })
        })
      }), /*#__PURE__*/_jsxs(UIDialogBody, {
        children: [this.renderAlertMaybe(), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: `userPreferences.${modalType}.descriptionModal`,
            options: {
              emailAddress,
              portalId: PortalIdParser.get()
            }
          })
        }), /*#__PURE__*/_jsx(UIFormControl, {
          className: "m-top-3",
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `userPreferences.${modalType}.matchConfirm.label`
          }),
          children: /*#__PURE__*/_jsx(UIMatchTextArea, {
            "data-test-id": "self-delete-email-match-input",
            match: emailAddress,
            onMatchedChange: this.handleMatchedChange
          })
        })]
      }), /*#__PURE__*/_jsxs(UIDialogFooter, {
        children: [/*#__PURE__*/_jsx(UILoadingButton, {
          use: "danger",
          loading: deletePending,
          failed: deleteFailed,
          onClick: this.handleConfirm,
          disabled: !isMatched,
          "data-test-id": "self-delete-modal-confirm-btn",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `userPreferences.${modalType}.confirmLabel`
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          use: "tertiary-light",
          onClick: onCloseModal,
          "data-test-id": "self-delete-modal-cancel-btn",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `userPreferences.${modalType}.rejectLabel`
          })
        })]
      })]
    });
  }
}
SelfDeletionConfirmModal.propTypes = {
  deletePending: PropTypes.bool.isRequired,
  deleteSucceeded: PropTypes.bool.isRequired,
  deleteFailed: PropTypes.bool.isRequired,
  emailAddress: PropTypes.string.isRequired,
  modalType: PropTypes.string.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  onConfirmAction: PropTypes.func.isRequired
};